module.exports = __webpack_public_path__ + "static/img/5.d6177d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/detail/common/medication/5.png
// module id = oxfx
// module chunks = 1